/**
 * CSV Export — triggers a browser file download from a CSV string.
 *
 * Note: this module deliberately does NOT build CSV from client-side Kalshi
 * order/position data. Trade exports are produced server-side by the relay
 * (/api/manager/.../trade-export.csv), which already reconstructs trader side
 * via the V2 order-read path. Raw KalshiOrder.side/action/yes_price reads on
 * the client invert rebooked buy-NO orders — see reconstructOrderTraderSide in
 * src/lib/kalshiApi/orderReadV2.ts. Route any future client-side export through
 * that reconstruction.
 */

/**
 * Trigger a browser file download from a CSV string.
 */
export function downloadCsv(csvContent: string, filename: string): void {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
